/**
 * 홈 화면 등에서 "이전에 풀다 만 검사가 있다"는 것을 감지했을 때 복귀 여부를 묻는 모달.
 * "취소"는 그냥 닫고, "복귀하기"는 상위가 넘긴 `onReturn`(이전 문제 풀이 화면으로 이동)을 실행한다.
 * `BaseDialog` 를 쓰므로 ESC·배경 클릭·포커스 트랩은 BaseDialog 가 처리한다.
 */
import React from "react";
import PauseModalIcon from "../icons/problem/PauseModalIcon";
import BaseDialog from "./BaseDialog";

interface ReturnModalProps {
  onClose: () => void;
  isOpen: boolean;
  onReturn: () => void;
}

const ReturnToTestModal: React.FC<ReturnModalProps> = ({
  onClose,
  isOpen,
  onReturn,
}) => {
  return (
    <BaseDialog
      isOpen={isOpen}
      onClose={onClose}
      ariaLabel="검사 복귀 안내"
      widthClassName="w-[360px] max-w-[calc(100vw-32px)]"
      containerClassName="bg-white pt-[36px] px-[20px] pb-[20px] rounded-[12px] flex flex-col justify-between"
    >
      <div className="flex flex-col items-center gap-y-[12px]">
        <PauseModalIcon />
        <span className="text-18 text-heading font-bold text-center font-heading">
          진행 중인 검사가 있습니다. <br />
          검사로 복귀하시겠습니까?
        </span>
        <span className="text-15 text-body text-center font-normal">
          이전에 풀던 시점부터 <br /> 이어서 진행할 수 있어요.
        </span>
      </div>

      <div className="mt-[10px] pt-[20px] flex gap-x-[10px]">
        <button
          type="button"
          onClick={onClose}
          className="gray-button w-full h-[47px] focus-visible:ring-2 focus-visible:ring-primary-focus focus-visible:outline-none"
        >
          취소
        </button>
        <button
          type="button"
          onClick={onReturn}
          data-autofocus
          className="blue-button w-full h-[47px] focus-visible:ring-2 focus-visible:ring-primary-focus focus-visible:outline-none"
        >
          복귀하기
        </button>
      </div>
    </BaseDialog>
  );
};

export default ReturnToTestModal;
